import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import AllUsers from '@jumbo/Dashboards/Users/AllUsers';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.usersPage'} />, isActive: true },
];

const Users = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.usersPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.usersPage.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <AllUsers />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Users;
